import { 
  OrganizationApi, 
  OrganizationProfessionalConfigurationApi 
} from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const organizationApi = new OrganizationApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);

export const organizationProfessionalConfigApi = new OrganizationProfessionalConfigurationApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);

export async function getAllOrganizations() {
  const response = await organizationApi.organizationControllerGetAllOrganizations();
  return response.data;
}
